import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import GridContainer from '../GridContainer/GridContainer'
import DropdownItem from '../DropdownItem/DropdownItem'
import { chunkArray } from '../../utils/chunkArray'

import {
    HoverLine,
    StyledViewportContainer,
    StyledDropdown,
    StyledDropdownHeader,
    StyledDropdownItems,
    StyledDropdownList,
    StyledSeparator,
    StyledAdditionnalReferenceDropdownItem,
} from './Dropdown.styled'

const getColumns = (
    links,
    selectedColumn,
    setSelectedColumn,
    selectedItem,
    setSelectedItem,
    menuLayout,
    additionalReference
) => {
    const columns = []

    const columnCount = additionalReference?.length ? 3 : menuLayout ? parseInt(menuLayout.charAt(0), 10) : 2
    const elementPerColumn = Math.ceil(links.length / columnCount)
    const chunkedItems = chunkArray(links, elementPerColumn)

    // Colonnes principales
    chunkedItems.forEach((chunk, columnIndex) => {
        const items = chunk
            .filter(link => link.pageReference !== null || link.slug !== null)
            .map((link, itemIndex) => (
                <DropdownItem
                    key={link.id}
                    columnId={columnIndex}
                    subItems={link.subNavigationItems}
                    itemId={itemIndex}
                    setSelectedColumn={setSelectedColumn}
                    selectedColumn={selectedColumn}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    slug={link.pageReference?.slug ?? link.slug}
                    title={link.name}
                />
            ))

        columns.push(
            <StyledDropdownItems key={`col-${columnIndex}`}>
                {items}
            </StyledDropdownItems>
        )
    })

    // Colonne additionnelle
    if (additionalReference?.length) {
        const additionnalReferenceItems = additionalReference
            .filter(link => link.pageReference !== null || link.slug !== null)
            .map((link, index) => (
                <DropdownItem
                    key={link.id}
                    columnId={columns.length}
                    subItems={link.subNavigationItems}
                    itemId={index}
                    setSelectedColumn={setSelectedColumn}
                    selectedColumn={selectedColumn}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    slug={link.pageReference?.slug ?? link.slug}
                    title={link.name}
                />
            ))

        columns.push(
            <StyledAdditionnalReferenceDropdownItem key="additionalReference">
                <StyledSeparator $isVisible={true} />
                <StyledDropdownItems>
                    {additionnalReferenceItems}
                </StyledDropdownItems>
            </StyledAdditionnalReferenceDropdownItem>
        )
    }

    return columns
}

const Dropdown = (props) => {
    const { label, links, slug, isSelected, scroll, menuLayout, additionalReference } = props
    const [isOpen, setIsOpen] = useState(false)
    const [selectedColumn, setSelectedColumn] = useState(null)
    const [selectedItem, setSelectedItem] = useState(null)

    const columns = getColumns(
        links,
        selectedColumn,
        setSelectedColumn,
        selectedItem,
        setSelectedItem,
        menuLayout,
        additionalReference
    )

    return (
        <StyledDropdown
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => {
                setSelectedColumn(null)
                setSelectedItem(null)
                setIsOpen(false)
            }}
        >
            {/* Lien principal */}
            <StyledDropdownHeader>
                <Link to={`/${slug}`}>{label}</Link>
                {scroll ? null : <HoverLine $isOpen={isOpen} $selected={isSelected} />}
            </StyledDropdownHeader>

            {/* Sous-liens */}
            <StyledDropdownList $isOpen={isOpen}>
                <StyledViewportContainer isFullWidth>
                    <GridContainer columns={columns.length} gap={24}>
                        {columns}
                    </GridContainer>
                </StyledViewportContainer>
            </StyledDropdownList>
        </StyledDropdown>
    )
}

Dropdown.propTypes = {
    label: PropTypes.string.isRequired,
    links: PropTypes.array.isRequired,
    slug: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    scroll: PropTypes.bool,
    menuLayout: PropTypes.string,
    additionalReference: PropTypes.array,
}

export default Dropdown
